export const FUEL_OPTIONS = [
  {
    label: 'Diesel',
    value: 'Diesel',
  },
  {
    label: 'Petrol',
    value: 'Petrol',
  },
  {
    label: 'CNG',
    value: 'CNG',
  },
];
